export const EndClient = ({ primaryFontColor = "#ffd800" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <g id="target" transform="translate(-1 -1)">
        <path
          id="Path_65840"
          data-name="Path 65840"
          d="M23.007,14.34a.867.867,0,0,1,.867-.867H25.13A10.851,10.851,0,0,0,15.207,3.55V4.807a.867.867,0,1,1-1.733,0V3.55A10.851,10.851,0,0,0,3.55,13.473H4.807a.867.867,0,1,1,0,1.733H3.55a10.851,10.851,0,0,0,9.923,9.923V23.873a.867.867,0,1,1,1.733,0V25.13a10.851,10.851,0,0,0,9.923-9.923H23.873A.867.867,0,0,1,23.007,14.34Zm-1.915,2.947a7.367,7.367,0,0,1-13.5,0,.867.867,0,0,1,0-.693,7.349,7.349,0,0,1,4.151-3.917,3.415,3.415,0,0,1-.867-2.236,3.467,3.467,0,1,1,6.933,0,3.415,3.415,0,0,1-.867,2.236,7.349,7.349,0,0,1,4.125,3.917A.867.867,0,0,1,21.091,17.287Z"
          transform="translate(-0.34 -0.34)"
          fill={primaryFontColor}
        />
        <circle
          id="Ellipse_1363"
          data-name="Ellipse 1363"
          cx="1.733"
          cy="1.733"
          r="1.733"
          transform="translate(12.267 8.367)"
          fill={primaryFontColor}
        />
        <ellipse
          id="Ellipse_1364"
          data-name="Ellipse 1364"
          cx="4.992"
          cy="3.033"
          rx="4.992"
          ry="3.033"
          transform="translate(9.008 13.567)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65841"
          data-name="Path 65841"
          d="M16.733,3.21V1.867a.867.867,0,1,0-1.733,0V3.21h.867S16.447,3.184,16.733,3.21Z"
          transform="translate(-1.867)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65842"
          data-name="Path 65842"
          d="M15,28.45v1.343a.867.867,0,0,0,1.733,0V28.45c-.286,0-.572.043-.867.043S15.286,28.476,15,28.45Z"
          transform="translate(-1.867 -3.66)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65843"
          data-name="Path 65843"
          d="M29.793,15H28.45c0,.286.043.572.043.867a5.75,5.75,0,0,1-.043.867h1.343a.867.867,0,0,0,0-1.733Z"
          transform="translate(-3.66 -1.867)"
          fill={primaryFontColor}
        />
        <path
          id="Path_65844"
          data-name="Path 65844"
          d="M3.21,15H1.867a.867.867,0,1,0,0,1.733H3.21v-.867C3.21,15.572,3.184,15.286,3.21,15Z"
          transform="translate(0 -1.867)"
          fill={primaryFontColor}
        />
      </g>
    </svg>
  );
};
